<div class="p-grid">
    <div class="p-col-10 p-m-auto">
        <div class="p-grid p-jc-between">
            <div class="p-col-5">
                <h1 class="p-mr-5 p-ml-5 p-mt-5">Registrar usuario</h1>
            </div>
        </div>

        <div class="delim p-ml-5 p-mr-5"></div>
        <form class="p-m-5" name="registroUsuarioForm" #registroUsuarioForm="ngForm">
            <div class="p-grid p-mb-3">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #nombre="ngModel" id="nombre" class="w-100" type="text " pInputText [(ngModel)]="newUser.nombre " name="nombre " required />
                    <label for="nombre">{{'GLOBAL.NOMBRE' | translate}}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.nombre.length === 0" class="p-invalid">{{'REGISTRO.USUARIO.NOMBRE.OBLIGATORIO' |translate}}</small>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #apellido="ngModel" id="apellido" class="w-100 " type="text " pInputText [(ngModel)]="newUser.apellido " name="apellido " required />
                    <label for="apellido">{{'GLOBAL.APELLIDOS' | translate}}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.apellido.length === 0" class="p-invalid">{{'REGISTRO.USUARIO.APELLIDOS.OBLIGATORIO' |translate}}</small>
                </div>
            </div>
            <div class="p-grid p-mb-3 ">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #nif="ngModel" id="nif" class="w-100 " type="text " pInputText [(ngModel)]="newUser.nif " (input)="validateNIF()" name="nif " required />
                    <label for="nif">{{'GLOBAL.NIF' | translate }}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.nif.length === 0 " class="p-invalid">{{'REGISTRO.USUARIO.NIF.OBLIGATORIO' |translate}}</small>
                    <small *ngIf="mensajeErrorNif && newUser.nif.length !== 0" class="p-invalid">{{'REGISTRO.USUARIO.NIF.FORMATO.INCORRECTO' |translate}}</small>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #user="ngModel" id="user" class="w-100 " type="text " pInputText [(ngModel)]="newUser.usuario " name="usuario " required />
                    <label for="user">{{'GLOBAL.USUARIO' | translate }}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.usuario.length === 0" class="p-invalid">{{'REGISTRO.USUARIO.USUARIO.OBLIGATORIO' |translate}}</small>
                </div>
            </div>
            <div class="p-grid p-mb-3 ">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #telefono="ngModel" id="telefono" class="w-100 " class="w-100 " type="text " pInputText minlength="9" maxlength="9"
                    [(ngModel)]="newUser.telefono " name="telefono " required />
                    <label for="telefono">{{'GLOBAL.TELEFONO' | translate  }}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.telefono.length === 0 " class="p-invalid">{{'REGISTRO.USUARIO.TELEFONO.OBLIGATORIO' |translate}}</small>
                    <small *ngIf="!validForm && telefono.invalid && newUser.telefono.length !== 0" class="p-invalid">{{'REGISTRO.USUARIO.TELEFONO.FORMATO.INCORRECTO' |translate}}.</small>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #email="ngModel" type="email" class="w-100" id="email" pInputText [(ngModel)]="newUser.email" name="email" (input)="validateEmail()" required/>
                    <label for="email">{{'GLOBAL.EMAIL' | translate }}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.email.length === 0 " class="p-invalid">{{'REGISTRO.USUARIO.EMAIL.OBLIGATORIO' |translate}}</small>
                    <small *ngIf="!validForm && mensajeErrorEmail" class="p-invalid">{{'REGISTRO.USUARIO.EMAIL.FORMATO.INCORRECTO' |translate}}</small>
                </div>
            </div>
            <div class="p-grid p-mb-3 ">
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #password="ngModel" id="password" type="password" pPassword  class="w-100" promptLabel="Contraseña" weakLabel="Debil" mediumLabel="Medio" strongLabel="Fuerte"
                    [(ngModel)]="newUser.password" name="password" required/>
                    <label for="password">{{'GLOBAL.CONTRASEÑA' | translate }}</label>
                  </span>
                    <small *ngIf="!validForm && newUser.password.length === 0" class="p-invalid">{{'REGISTRO.USUARIO.PASSWORD.OBLIGATORIO' |translate}}.</small>
                </div>
                <div class="p-xl-6 p-lg-6 p-md-6 p-sm-12">
                  <span class="ui-float-label">
                    <input #passwordRepetida="ngModel" id="passwordRepetida" class="w-100" promptLabel="Repetir contraseña" weakLabel="Debil" mediumLabel="Medio" strongLabel="Fuerte"
                    type="password" pPassword [(ngModel)]="contrasenaRepetida" name="contrasenaRepetida" required/>
                    <label for="passwordRepetida">{{'GLOBAL.REPETIR.CONTRASEÑA' | translate  }}</label>
                  </span>
                    <small *ngIf="password.dirty && contrasenaRepetida.length === 0" class="p-invalid">{{'REGISTRO.USUARIO.PASSWORD.REPETIR.OBLIGATORIO' |translate}}</small>
                    <small *ngIf="newUser.password !== contrasenaRepetida" class="p-invalid">{{'REGISTRO.USUARIO.PASSWORDS.IGUALES' |translate}}</small>
                </div>
            </div>

            <div class="p-grid p-jc-between p-mb-2 ">
              <div class="p-col-2 p-d-flex p-jc-start">
                <label for="">Registrar vehículo</label>
                <p-inputSwitch name="hasVehiculo" [(ngModel)]="hasVehiculo"></p-inputSwitch>
              </div>
                <div class="p-col-2 p-d-flex p-jc-end">
                    <button class="pr-2 pl-2 pb-1 pt-1 " type="submit " pButton [label]=" 'GLOBAL.SIGUIENTE' | translate " (click)="siguienteRegistro() "></button>
                </div>
            </div>
        </form>
        <dum-toast #dumToast></dum-toast>
    </div>


</div>
